import { CSSProperties } from 'react'
import { RenderElementProps } from 'slate-react'

const RenderElement = ({ attributes, children, element }: RenderElementProps) => {
  const style = { textAlign: element.align } as CSSProperties
  return (
    <p style={style} {...attributes}>
      {children}
    </p>
  )
}

export default RenderElement
